import ApiBase from '../ApiBase';

class Support extends ApiBase {
  /**
   * @method send
   * @param {object} data
   * @return {Promise<*>}
   */
  send = (data) => {
    return this.post(`support`, data, null, 200, {
      transformRequest: (data) => {
        const formData = new FormData();

        formData.append('email', data.email);
        formData.append('message', data.message);
        formData.append('name', data.name);
        formData.append('number', data.number);
        formData.append('type', data.type);
        formData.append('version', data.version);
        formData.append('path', data.path);

        if (data.file !== null) {
          formData.append('file', data.file);
        }

        return formData;
      },
      headers: {
        'Content-Type': undefined
      }
    });
  };
}

export default new Support();
